export const ArrowRightIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M14.1212 6.7793L18 11.7793M18 11.7793L14.1212 16.7793M18 11.7793L6 11.7793"
      stroke="currentColor"
      strokeOpacity="0.86"
      strokeLinecap="round"
    />
  </svg>
);
